import {cssStyleResponsive} from '../utils/propsUtils';

const map = (value) => value === 0 ? 'auto' : value === 'full' ? '100%' : `${value}px`;

/**
 "size": {
      "maxWidth": "1445",
      "height": 200,
      "width": 219,
      "maxHeight": "1445"
    }
 * */
export const sizeStyle = ({size}, viewport) => {
  const {width, height, maxWidth, maxHeight} = size || {};
  return `
     ${cssStyleResponsive(viewport, 'width', width, map)}
     ${cssStyleResponsive(viewport, 'height', height, map)}
     ${cssStyleResponsive(viewport, 'max-width', maxWidth, map)}
     ${cssStyleResponsive(viewport, 'max-height', maxHeight, map)}
 
  `;
};

const paddingStyle = ({padding}, viewport) => {
  const {paddingTop, paddingRight, paddingBottom, paddingLeft} = padding || {};
  return `
     ${cssStyleResponsive(viewport, 'padding-top', paddingTop, null, 'px')}
     ${cssStyleResponsive(viewport, 'padding-right', paddingRight, null, 'px')}
     ${cssStyleResponsive(viewport, 'padding-bottom', paddingBottom, null, 'px')}
     ${cssStyleResponsive(viewport, 'padding-left', paddingLeft, null, 'px')}
  `;
};

const marginStyle = ({margin}, viewport) => {
  const {marginTop, marginRight, marginBottom, marginLeft} = margin || {};
  return `
     ${cssStyleResponsive(viewport, 'margin-top', marginTop, null, 'px')}
     ${cssStyleResponsive(viewport, 'margin-right', marginRight, null, 'px')}
     ${cssStyleResponsive(viewport, 'margin-bottom', marginBottom, null, 'px')}
     ${cssStyleResponsive(viewport, 'margin-left', marginLeft, null, 'px')}
  `;
};
/**
 "box": {
    "size": {
      "maxWidth": "1445",
      "height": 200,
      "width": 219,
      "maxHeight": "1445"
    }
  }
 * */
export const boxCss = ({box = {}, viewport}) => {
  return `
     ${sizeStyle(box, viewport)}
     ${paddingStyle(box, viewport)}
     ${marginStyle(box, viewport)}
  `;
};

export const sizeCss = ({box = {}, viewport}) => {
  return sizeStyle(box, viewport);
};

export const paddingCss = ({box = {}, viewport}) => {
  return paddingStyle(box, viewport);
};

export const marginCss = ({box = {}, viewport}) => {
  return marginStyle(box, viewport);
};

